import AdminActions from '../services/AdminActions';
import decodePolValues from './UtilPolValues';

// Decoding on every check would be wasteful, so the last result is cached and
// reused while the user keeps the same policy.
let cachedSource = null;
let cachedValues = {};

const isSuperAdmin = (currentUser) =>
  currentUser?.role === AdminActions.ROLE.SUPERADMIN;

const getPolValues = (currentUser) => {
  const source = currentUser?.userPolicy?.polValues;

  if (!source) return {};
  if (source === cachedSource) return cachedValues;

  const values = decodePolValues(source);
  cachedSource = source;
  cachedValues = values;
  return values;
};

// A user without any policy (the backend did not send polValues) keeps the
// app fully reachable, so a missing field cannot blank out the menu. A policy
// that exists restricts, even when it grants nothing: a role with every
// switch off must not become a full admin.
const hasUsablePolicy = (currentUser) => Boolean(currentUser?.userPolicy?.polValues);

// Accepts a single key or a list of keys. A list passes when ANY key is granted.
const hasPermission = (name, currentUser) => {
  if (!name) return true;
  if (isSuperAdmin(currentUser)) return true;
  if (!hasUsablePolicy(currentUser)) return true;

  const values = getPolValues(currentUser);
  const names = Array.isArray(name) ? name : [name];

  return names.some((key) => values[key] === true);
};

// First page the user may open, in menu order; used instead of a fixed
// /dashboard so a role without the dashboard never lands on a blank page.
const HOME_PATHS = [
  ['/dashboard', 'useDashboard'],
  ['/job_repairs', 'viewJobRepairs'],
  ['/reports', 'useReports'],
  ['/definitions', 'useDefinitions'],
  ['/job_repair_settings', 'useJobRepairSettings'],
  ['/users', 'viewUsers'],
  ['/activity_log', 'useActivityLog'],
  ['/permissions', 'viewPermissions'],
];

const getHomePath = (currentUser) =>
  HOME_PATHS.find(([, key]) => hasPermission(key, currentUser))?.[0] ||
  '/profile';

const UtilPermission = {
  getHomePath,
  isSuperAdmin,
  hasUsablePolicy,
  getPolValues,
  hasPermission,
};

export default UtilPermission;
